import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/footer/language-select-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header/NavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/home-page/body/Fullscreenslider.tsx");
